import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Navigation from "./components/Navigation";
import HomePage from "./pages/HomePage";
import Dashboard from "./pages/Dashboard";
import LessonPage from "./pages/LessonPage";
import PaymentPage from "./pages/PaymentPage";
import "./styles/App.css";
import LoginPage from "./components/Auth/LoginPage"; // 👈 ADD THIS
import RegisterPage from "./components/Auth/RegisterPage"; // 👈 ADD THIS
import "./styles/App.css";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Navigation />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/lesson/:id" element={<LessonPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/login" element={<LoginPage />} /> {/* 👈 ADD THIS */}
            <Route path="/register" element={<RegisterPage />} />{" "}
            {/* 👈 ADD THIS */}
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
